"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderCalendar = void 0;
var calendar_data_1 = require("./calendar-data");
function buildDetailItems(month) {
    var weekdaySuffix = month.weekday.suffix ? " ".concat(month.weekday.suffix) : '';
    var weekendStrike = month.weekend.strikeText
        ? "<span class=\"calendar_detail-item_text-strong strike\">".concat(month.weekend.strikeText, "</span>")
        : '';
    var weekendSuffix = month.weekend.suffix ? " ".concat(month.weekend.suffix) : '';
    var extraDetail = month.extraDetail
        ? "\n    <li class=\"calendar_detail-item\">\n      <div class=\"calendar_detail-item_dot is-color-".concat(month.extraDetail.dotColor).concat(month.extraDetail.dotHasBorder ? ' has-border' : '', "\"></div>\n      <span class=\"calendar_detail-item_text\">\n        ").concat(month.extraDetail.label, "\n        <span class=\"calendar_detail-item_text-strong\">").concat(month.extraDetail.mainText, "</span>\n      </span>\n    </li>")
        : '';
    var closedDayExtras = month.closedDayExtras
        ? month.closedDayExtras
            .map(function (item) { return "\n    <li class=\"calendar_detail-item\">\n      <div class=\"calendar_detail-item_dot is-color-".concat(item.dotColor).concat(item.dotHasBorder ? ' has-border' : '', "\"></div>\n      <span class=\"calendar_detail-item_text\">").concat(item.label, "</span>\n    </li>"); })
            .join('')
        : '';
    var note = month.note ? "<li class=\"calendar_detail-item\">".concat(month.note, "</li>") : '';
    return "\n    <li class=\"calendar_detail-item\">\n      <div class=\"calendar_detail-item_dot is-color-secondary\"></div>\n      <span class=\"calendar_detail-item_text\">\n        \u5E73\u65E5\n        <span class=\"calendar_detail-item_text-strong\">".concat(month.weekday.mainText, "</span>").concat(weekdaySuffix, "\n      </span>\n    </li>\n    <li class=\"calendar_detail-item\">\n      <div class=\"calendar_detail-item_dot is-color-blue\"></div>\n      <span class=\"calendar_detail-item_text\">\n        \u571F\u65E5\u795D\n        ").concat(weekendStrike, "\n        <span class=\"calendar_detail-item_text-strong\">").concat(month.weekend.mainText, "</span>").concat(weekendSuffix, "\n      </span>\n    </li>\n    ").concat(extraDetail, "\n    <li class=\"calendar_detail-item\">\n      <div class=\"calendar_detail-item_dot is-color-gray has-border\"></div>\n      <span class=\"calendar_detail-item_text\">\u5B9A\u4F11\u65E5</span>\n    </li>\n    ").concat(closedDayExtras, "\n    ").concat(note, "\n  ");
}
function buildCalendarItem(month) {
    return "\n    <li class=\"calendar_main-item\">\n      <div class=\"calendar_main-item_image js-fadeIn\">\n        <img src=\"./img/calendar/calendar-".concat(month.imageId, ".png\" width=\"800\" height=\"800\" alt=\"\u753B\u50CF\" />\n      </div>\n      <ul class=\"calendar_detail-list js-slideUp\">\n        ").concat(buildDetailItems(month), "\n      </ul>\n    </li>\n  ");
}
function getDisplayOrder(imageId) {
    var month = Number(imageId);
    // 8月以降と年始（1〜7月）が同時表示のとき、年始は12月の次に並べる
    return month <= 7 ? month + 12 : month;
}
function sortActiveMonths(months) {
    var hasEarlyYear = months.some(function (month) { return Number(month.imageId) <= 7; });
    var hasAugustOrLater = months.some(function (month) { return Number(month.imageId) >= 8; });
    if (hasEarlyYear && hasAugustOrLater) {
        return __spreadArray([], months, true).sort(function (a, b) { return getDisplayOrder(a.imageId) - getDisplayOrder(b.imageId); });
    }
    return __spreadArray([], months, true).sort(function (a, b) { return Number(a.imageId) - Number(b.imageId); });
}
function renderCalendar() {
    var list = document.getElementById('js-calendarList');
    if (!list)
        return;
    list.innerHTML = sortActiveMonths(calendar_data_1.calendarData.filter(function (month) { return month.active; }))
        .map(buildCalendarItem)
        .join('');
}
exports.renderCalendar = renderCalendar;
